import { Layer as ParseLayer } from '@meitu-graphic/ag-psd';
import { computerBgRatio } from '@meitu/saas-editor-core/es/utils/layer-kit';
import { getDefaultClientBackgroundValue } from '@meitu/saas-editor-core/es/version-parse/constants';
import { IBackgroundLayerProps, ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import { PsdParseWarnType, UploadImage, WarnOrErrorCallbackFunc } from './types';
import { canSaveToJpg, getUrlByCanvas, isBgLayer, isGroupLayer, isTextLayer, isVectorLayer } from './utils';

export const getBgLayer = async (
    stageWidth: number,
    stageHeight: number,
    layer: ParseLayer,
    uploadFile: UploadImage,
    warnOrErrorCallback?: WarnOrErrorCallbackFunc,
    parseNoLimit = false,
    parseLayerCallback?: (originLayer: ParseLayer, resultLayer: ILayerProps) => Promise<ILayerProps>,
) => {
    if (!isBgLayer(layer) && !parseNoLimit) {
        warnOrErrorCallback && warnOrErrorCallback('没有背景图层', PsdParseWarnType.Error);
    }

    if (parseNoLimit && (isGroupLayer(layer) || isVectorLayer(layer) || isTextLayer(layer) || !isBgLayer(layer))) {
        return null;
    }

    const { canvas, opacity = 1, name } = layer;

    const bgLayer = getDefaultClientBackgroundValue(stageWidth, stageHeight);
    warnOrErrorCallback && warnOrErrorCallback(`解析文本图层：${bgLayer.title}`, PsdParseWarnType.Info);
    bgLayer.opacity = opacity * (layer.fillOpacity || 1);
    const data = bgLayer.data as IBackgroundLayerProps;

    if (canvas) {
        const { width, height } = canvas;
        data.naturalWidth = width;
        data.naturalHeight = height;

        if (width === 0 || height === 0) {
            if (parseNoLimit) {
                return null;
            }
            warnOrErrorCallback && !parseNoLimit && warnOrErrorCallback('背景图层宽高不能为0', PsdParseWarnType.Error);
        }

        if (width < 10 && height < 10) {
            if (parseNoLimit) {
                return null;
            }
            warnOrErrorCallback &&
                !parseNoLimit &&
                warnOrErrorCallback('背景图层宽高不能都小于10', PsdParseWarnType.Error);
        }

        if (width > stageWidth * 2 || height > stageHeight * 2) {
            warnOrErrorCallback &&
                !parseNoLimit &&
                warnOrErrorCallback('背景图层宽高不得大于当前画布尺寸2倍及以上', PsdParseWarnType.Error);
        }

        let mineType = 'image/png';
        if (canSaveToJpg(canvas)) {
            mineType = 'image/jpeg';
        }
        data.url = await getUrlByCanvas(name || '背景图层', canvas, uploadFile, mineType);
        data.imageTransform = {
            ...data.imageTransform,
            ...computerBgRatio({
                imgWidth: width,
                imgHeight: height,
                stageWidth: width,
                stageHeight: height,
            }),
        };
    }

    if (parseLayerCallback) {
        const newLayer = await parseLayerCallback(layer, bgLayer);
        return newLayer;
    }

    return bgLayer;
};
